import { ReactElement, SVGProps, useEffect } from 'react';
import { assetUrl, cn } from '@Shared/Helpers/Utilities';
import { usePage } from '@inertiajs/react';

const collections: string[] = [];

interface BaseSvgSpriteProps extends SVGProps<SVGSVGElement> {
    testid: string;
    iconId: string;
    collectionName: string;
    prefix: string;
    className?: string | null;
}

const BaseSvgSprite = ({
    className = null,
    testid,
    prefix,
    collectionName,
    iconId,
    ...rest
}: BaseSvgSpriteProps): ReactElement => {
    const currentCommitHash = usePage().props.currentCommitHash || 'latest';
    const collection = `${prefix}-${collectionName}`;
    const url = assetUrl(
        `/assets/images/svg/${prefix}/${collectionName}.svg?v=${currentCommitHash}`
    );

    useEffect(() => {
        if (!collections.includes(collection)) {
            collections.push(collection);

            fetch(url)
                .then((res) => res.text())
                .then((svg) => {
                    const wrapper = document.createElement('div');
                    wrapper.innerHTML = svg;

                    const elementsWithId = wrapper.querySelectorAll<HTMLElement>('[id]');
                    elementsWithId.forEach((el) => {
                        el.id = `${collection}-${el.id}`;
                    });

                    const svgs = wrapper.querySelectorAll<SVGElement>('svg');
                    svgs.forEach((el) => {
                        el.id = collection;
                        el.style.display = 'none';
                    });

                    const firstChild = wrapper.firstChild;
                    if (firstChild) {
                        document.body.appendChild(firstChild);
                    }
                });
        }
    }, [collection, url]);

    return (
        <svg data-testid={testid} className={cn('size-6', className)} {...rest}>
            <use xlinkHref={`#${collection}-${iconId}`} />
        </svg>
    );
};

export default BaseSvgSprite;
